module.exports = __webpack_public_path__ + "static/media/step-1.c259de2b.png";